// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3-0cG","box":"WorkspacesBox_box__2SU_p","node":"WorkspacesBox_node__1dOnP"};